import AddToWalletLayout from './AddToWalletLayout';

export default AddToWalletLayout;
